"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
class NotFoundError extends Error {
  constructor(message = `Not Found`) {
    super(message);
    this.message = message;
  }
}
const usePageData = options => {
  const [data, setData] = (0, _react.useState)(null);
  const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
  const refetch = async () => {
    const urlHostString = window.location.origin;
    const pathAdjustment = window.location.pathname === `/` ? `/index` : window.location.pathname;
    const normalizedPath = `/page-data${pathAdjustment}/page-data.json`.replace(/\/\//g, `/`);
    const url = urlHostString + normalizedPath;
    try {
      const response = await fetch(url);
      const data = await response.text();

      // for local dev with `gatsby develop` where page-data.json files never 404 and return an empty object instead.
      if (data === `{}`) {
        // for local development, force an error if page is missing.
        throw new NotFoundError();
      }
      setData(data);
      setErrorMessage(null);
    } catch (e) {
      setData(null);
      if (e instanceof NotFoundError) {
        setErrorMessage(`This page has moved.`);
      } else {
        setErrorMessage(null);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (!options || options !== null && options !== void 0 && options.immediate) {
      refetch();
    }
  }, []);
  return {
    data,
    errorMessage,
    refetch
  };
};
var _default = usePageData;
exports.default = _default;